// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/revenue.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ComparisionItem, ComparisionItemWithPaymentMode, SalesCountByDate } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.RevenueReportRequest
 */
export class RevenueReportRequest extends Message<RevenueReportRequest> {
  /**
   * Start date for the report (timestamp)
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report (timestamp)
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  constructor(data?: PartialMessage<RevenueReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RevenueReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevenueReportRequest {
    return new RevenueReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevenueReportRequest {
    return new RevenueReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevenueReportRequest {
    return new RevenueReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RevenueReportRequest | PlainMessage<RevenueReportRequest> | undefined, b: RevenueReportRequest | PlainMessage<RevenueReportRequest> | undefined): boolean {
    return proto3.util.equals(RevenueReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.RevenueReportResponse
 */
export class RevenueReportResponse extends Message<RevenueReportResponse> {
  /**
   * Gross revenue for the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem gross_revenue = 1;
   */
  grossRevenue?: ComparisionItem;

  /**
   * Net revenue for the period after discounts
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem net_revenue = 2;
   */
  netRevenue?: ComparisionItem;

  /**
   * Total tax collected during the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_tax_collected = 3;
   */
  totalTaxCollected?: ComparisionItem;

  /**
   * Total refunded revenue during the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_refunded_revenue = 4;
   */
  totalRefundedRevenue?: ComparisionItem;

  /**
   * Total discounts given during the period
   *
   * @generated from field: com.neulink.pharmacy.ComparisionItem total_discounts_given = 5;
   */
  totalDiscountsGiven?: ComparisionItem;

  /**
   * Revenue breakdown by payment mode
   *
   * @generated from field: repeated com.neulink.pharmacy.ComparisionItemWithPaymentMode revenue_by_payment_mode = 6;
   */
  revenueByPaymentMode: ComparisionItemWithPaymentMode[] = [];

  /**
   * Sales count breakdown by date
   *
   * @generated from field: repeated com.neulink.pharmacy.SalesCountByDate sales_count_by_date = 7;
   */
  salesCountByDate: SalesCountByDate[] = [];

  constructor(data?: PartialMessage<RevenueReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RevenueReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gross_revenue", kind: "message", T: ComparisionItem },
    { no: 2, name: "net_revenue", kind: "message", T: ComparisionItem },
    { no: 3, name: "total_tax_collected", kind: "message", T: ComparisionItem },
    { no: 4, name: "total_refunded_revenue", kind: "message", T: ComparisionItem },
    { no: 5, name: "total_discounts_given", kind: "message", T: ComparisionItem },
    { no: 6, name: "revenue_by_payment_mode", kind: "message", T: ComparisionItemWithPaymentMode, repeated: true },
    { no: 7, name: "sales_count_by_date", kind: "message", T: SalesCountByDate, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevenueReportResponse {
    return new RevenueReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevenueReportResponse {
    return new RevenueReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevenueReportResponse {
    return new RevenueReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RevenueReportResponse | PlainMessage<RevenueReportResponse> | undefined, b: RevenueReportResponse | PlainMessage<RevenueReportResponse> | undefined): boolean {
    return proto3.util.equals(RevenueReportResponse, a, b);
  }
}

